<app-lms-modal-frame [title]="'Money Laundering Scorecard'" [pageHeadWidth]="400">
  <div modal-body>
    <form [formGroup]="editRiskScoreForm" novalidate>
      <table class="table table-striped table-light table-hover table-sm mb-3 w-100">
        <caption>Edit Risk Score</caption>
        <tbody>
          <tr align="left">
            <td style="width: 25%;">Parameter Type</td>
            <td style="width: 25%;">
              <input formControlName="parameterType" [(ngModel)]="riskScoreModel.parameterType" required>
              <div *ngIf="validateRiskScoreValues.parameterType.errors?.required && submitted" class="error-label">
                Parameter Type is required
              </div>
            </td>
          </tr>
          <tr align="left">
            <td style="width: 25%;">Description</td>
            <td style="width: 25%;">
              <input formControlName="description" [(ngModel)]="riskScoreModel.description"
                (keypress)="omit_special_char($event)"
                required>
              <div *ngIf="validateRiskScoreValues.description.errors?.required && submitted" class="error-label">
                Description is required
              </div>
            </td>

          </tr>
          <tr align="left">
            <td>Score</td>
            <td>
              <input formControlName="score" type="number" [(ngModel)]="riskScoreModel.score" required>
              <div *ngIf="validateRiskScoreValues.score.errors?.required && submitted" class="error-label">
                Score is required
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary" mdbRipple (click)="close()">Close</button>
    <button class="btn btn-primary" mdbRipple (click)="saveRiskScore()">Save</button>
  </div>
</app-lms-modal-frame>
